<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="isAllowedToCreate"
            :title="'Přidat balíček' | translate"
            route-name="packageNew"
        ></add-button>
        <h1 v-translate>Balíčky</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <div class="field_right" v-if="$_loggedUser_action_allowed('businessModels')">
            <select-box
                id="businessmodel"
                :options="businessModelOptions"
                v-model="formFields.businessModel"
                ref="businessmodelref"
            >
              <translate class="translate">Business model</translate>
            </select-box>
          </div>
          <div class="field_left" v-if="$_readActionAllowedAll">
            <select-box
                id="packagetype"
                :options="packageTypeOptions"
                v-model="formFields.packageType"
                ref="packagetyperef"
            >
              <translate class="translate">Typ balíčku</translate>
            </select-box>
          </div>
          <div class="field_right" v-if="showOperatorFilter">
            <select-box
                id="operatorselect"
                :options="operatorOptions"
                v-model="formFields.operator"
                ref="operatorselectref"
            >
              <translate class="translate">Operátor</translate>
            </select-box>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="package-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <package-row v-for="entity in entities"
                             :entity="entity"
                             :key="entity.id"
                             :selected-packages="selectedEntities"
                             ref="package_row"
                             @input="select"
                             @updatePackage="updateEntity"
                             @deletePackage="deleteEntity"
                ></package-row>
                <tr v-if="entities.length === 0">
                     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné balíčky.') }}</td>
                </tr>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              table-id="package-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import PackageRow from "@/components/views/packages/PackageRow"
import listActions from "@/components/mixins/list-actions"
import {prependOptions} from "@/utils/helpers"

export default {
  name: "PackageList",
  components: {
    PackageRow,
  },
  mixins: [listActions],
  data: function () {
    return {
      moduleName: 'packages',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
        businessModel: null,
        packageType: 'all',
        operator: 0,
      },
      businessModels: [],
      operators: [],
    }
  },
  created(PackageService,
          BusinessModelService,
          OperatorService,
  ) {
    this.entityService = PackageService
    this.businessModelService = BusinessModelService
    this.operatorService = OperatorService;

    if (this.$_readActionAllowedAll) {
      this.businessModelService.getEntities()
          .then((data) => {
            this.businessModels = [{'id': null, 'name': this.$gettext('Všechny')}, ...data['business_models']];
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    }
    if(this.$_loggedUser_canChangeOperator) {
      this.loadOperators();
    }
    this.createdInit()
  },
  computed: {
    isAllowedToCreate() {
      return this.$_loggedUser_canCreateChannelPackage && this.$_createActionAllowed;
    },
    multipleActionOptions() {
      let options = [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
      if(this.$_updateActionAllowed){
        options.push({value: 'activate', text: this.$gettext('Aktivovat')})
        options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')})
      }
      if(this.$_deleteActionAllowed){
        options.push({value: 'delete', text: this.$gettext('Smazat')})
      }

      return options;
    },
    businessModelOptions() {
      if (this.businessModels) {
        return this._.map(this.businessModels, function (item) {
          return {id: item['id'], text: item['name']}
        });
      } else {
        return []
      }
    },
    packageTypeOptions() {
      return [
        {id: 'all', text: this.$gettext('Všechny')},
        {id: 'basic', text: this.$gettext('Základní')},
        {id: 'thematic', text: this.$gettext('Tématický')},
      ]
    },
    sortingTableTitlesOperator() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Typ'), column: 'sType'},
        {key: 3, name: this.$gettext('Komb. se zákl.'), column: 'sCombWithBasic'},
        {key: 4, name: this.$gettext('Komb. s témat.'), column: 'sCombWithThematic'},
        {key: 5, name: this.$gettext('Počet kanálů v balíčku'), column: 'sChannelsCount'},
        {key: 6, name: this.$gettext('Cena'), column: 'sPrice', right: true},
      ]
    },
    sortingTableTitlesOwner() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Operátor'), column: 'sOperator'},
        {key: 3, name: this.$gettext('Business model'), column: 'sBusinessModel'},
        {key: 4, name: this.$gettext('Typ'), column: 'sType'},
        {key: 5, name: this.$gettext('Komb. se zákl.'), column: 'sCombWithBasic'},
        {key: 6, name: this.$gettext('Komb. s témat.'), column: 'sCombWithThematic'},
        {key: 7, name: this.$gettext('Počet kanálů v balíčku'), column: 'sChannelsCount'},
        {key: 8, name: this.$gettext('Cena'), column: 'sPrice', right: true},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      if(headers.hasOwnProperty("operator")){
         headers.operator.callback = (entity) => {return entity.operator_name; };
      }
      if(headers.hasOwnProperty("business_model")){
        headers.business_model.callback = (entity, index) => {return this.$refs.package_row[index].businessModelNames();};
      }
      headers.type.callback = (entity, index) => {return this.$refs.package_row[index].channelType(); };
      headers.comb_with_basic.callback = (entity, index) => {return this.$refs.package_row[index].channelCombinationWithBasic(); };
      headers.comb_with_thematic.callback = (entity, index) => {return this.$refs.package_row[index].channelCombinationWithThematic(); };
      headers.channels_count.callback = (entity, index) => {return this.$refs.package_row[index].channelsCount(); };
      headers.price.callback = (entity, index) => {return this.$refs.package_row[index].priceDisplayValue(); };

      return headers;
    },
    sortingTableTitles() {
      if (this.$_readActionAllowedAllOrOwnAndGlobal) {
        return this.sortingTableTitlesOwner
      } else {
        return this.sortingTableTitlesOperator
      }
    },
    operatorOptions() {
      if (this.operators) {
        let data = this._.map(this.operators, function (item) {
          return {id: item['id'], text: item['name']}
        });
        data.unshift({'id': 'global', 'text':this.$gettext('Pouze globální')});
        data.unshift({'id': 0, 'text':this.$gettext('Všechny')});
        return [...data];
      } else {
        return []
      }
    },
    showOperatorFilter(){
      return this.$_loggedUser_action_allowed('operators') && this.$_loggedUser_canChangeOperator && this.getOwnerSettingByKey('selected-operator-id') == null;
    },
  },
  methods: {
    loadOperators(){
      this.operatorService.getOperators({id_business_model: this.formFields.businessModel})
          .then((data) => {
            this.operators = data['operators']
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    },
    toggleSelectAll(value) {
      let selected = []
      if (value) {
        this.entities.forEach(function (item) {
          if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            selected.push(String(item.id))
          }
        }.bind(this))
      }
      this.selectedEntities = selected
    },
    executeMultipleAction(action) {
      if (action === 'activate') {
        this.updateEntity({'id': this.filteredSelectedEntities.join(), 'params': {enabled: true}})
      } else if (action === 'deactivate') {
        this.updateEntity({'id': this.filteredSelectedEntities.join(), 'params': {enabled: false}})
      } else if (action === 'delete') {
        this.deleteEntity(this.filteredSelectedEntities.join())
      }else{
        this.runMultipleAction(action);
      }
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('packageType')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('businessModel') && this.formFields.businessModel !== 0) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('operator') && this.formFields.operator !== 0) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('packageType', this.formFields.packageType)
      this.setUserSetting('businessModel', this.formFields.businessModel)
      this.setUserSetting('operator', this.formFields.operator)
    },
    _processListErrorMessage(error) {
      return error['error_message']
    }
  },
  watch: {
    "formFields.businessModel"(){
      this.formFields.operator = 0;
      this.loadOperators();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/packages/PackageList.vue